
import React from 'react';

export default function Footer() {
  /** 
   * Handles the click on the e‑mail button.
   * Builds a proper `mailto:` URL from the splitted parts and
   * navigates the browser to it. If anything goes wrong we
   * gracefully log the error instead of breaking the UI.
   */
  const handleEmailClick = () => {
    try {
      const username = 'justine.marie';
      const domain = 'gmail.com';
      // Construct a valid mailto link
      const mailtoLink = `mailto:${username}@${domain}`;
      // Using `window.location.assign` instead of directly setting `href`
      // ensures the navigation is intentional and can be mocked in tests.
      window.location.assign(mailtoLink);
    } catch (err) {
      // Fallback: show the e‑mail in an alert so the user still gets the info.
      console.error('Failed to open mail client:', err);
      alert('Unable to open your mail client. Please email: justine.marie@gmail.com');
    }
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 py-12 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <a
              href="https://www.linkedin.com/in/justinesacco"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-[#FF4D00] transition-colors cursor-pointer"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-2xl w-8 h-8 flex items-center justify-center"></i>
            </a>

            <button
              onClick={handleEmailClick}
              className="text-gray-400 hover:text-[#FF4D00] transition-colors cursor-pointer bg-transparent border-none p-0"
              aria-label="Email"
              type="button"
            >
              <i className="ri-mail-line text-2xl w-8 h-8 flex items-center justify-center"></i>
            </button>
          </div>

          <div className="text-sm text-gray-500 text-center md:text-right">
            <p>© {new Date().getFullYear()} Justine Sacco. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
